import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AddCall } from 'src/providers/addvCall';

@Component({
  selector: 'app-room-details',
  templateUrl: './room-details.page.html',
  styleUrls: ['./room-details.page.scss'],
})
export class RoomDetailsPage implements OnInit {

  roomdetails : any;
  constructor(
    public modalCtrl : ModalController,
    public addCall: AddCall,
  ) { }

  ngOnInit() {
    console.log(this.roomdetails,"room details");
    
  }
  async ionViewWillEnter() {
    if(this.roomdetails.length > 0){
      this.roomdetails = this.roomdetails
    }else {
      this.roomdetails = []
    }
  }


  dismiss() {
    this.modalCtrl.dismiss({
      selected_roomid: null
    });
   
  }


  selectpro(Value,i){
   // console.log("select program",this.selectprogram[0])
    this.modalCtrl.dismiss({
      selected_roomid: Value ,
      indexval:i,
    });
  }

  defaultImage = 'assets/img/Vector.png';
  
  onImageError(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = this.defaultImage;
  }


}
